import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type SelectAllStore = {
  selectAll: boolean;
  setSelectAll: (selectAll: boolean) => void;
};

export const useSelectAllStore = create(
  immer<SelectAllStore>((set) => {
    return {
      selectAll: false,
      setSelectAll: (selectAll: boolean) =>
        set((state) => {
          state.selectAll = selectAll;
        }),
    };
  }),
);
